// extracted by mini-css-extract-plugin
export var attribution = "_d3-4";
export var authorName = "_d3-5";
export var quote = "_d3-3";
export var testimonial = "_d3-2";
export var trustedBy = "_d3-0";
export var trustedByLabel = "_d3-1";